var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystembusy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22929",
    "data-name": "Group 22929",
    transform: "translate(2207 946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6566",
    "data-name": "Rectangle 6566",
    transform: "translate(-2207 -946)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-clock",
    d: "M8.286,2a6.286,6.286,0,1,0,6.286,6.286A6.286,6.286,0,0,0,8.286,2Zm1.625,8.8L7.841,8.73a.628.628,0,0,1-.184-.444V5.143a.629.629,0,0,1,.629-.629h0a.629.629,0,0,1,.629.629V8.025L10.8,9.911a.629.629,0,0,1,0,.889h0A.629.629,0,0,1,9.911,10.8Z",
    transform: "translate(-2207.285 -946.285)",
    fill: "#ecad00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystembusy);
export default __webpack_public_path__ + "static/media/systembusy.056951cc60a1881fd627ad967053b310.svg";
export { ForwardRef as ReactComponent };